var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3035 2C14.8868 0.666667 16.7785 0.666667 17.3601 2L20.2801 8.70333C20.4012 8.98065 20.5955 9.21977 20.8421 9.39506C21.0887 9.57035 21.3784 9.67519 21.6801 9.69833L29.1185 10.2683C30.6185 10.3833 31.2101 12.2683 30.0451 13.22L24.4951 17.7583C24.2507 17.9584 24.0681 18.2237 23.9687 18.5235C23.8692 18.8233 23.857 19.1452 23.9335 19.4517L25.6501 26.3167C26.0068 27.7467 24.4668 28.9033 23.1935 28.16L16.6718 24.3583C16.4169 24.2096 16.127 24.1312 15.8318 24.1312C15.5366 24.1312 15.2468 24.2096 14.9918 24.3583L8.47014 28.16C7.1968 28.9033 5.6568 27.7467 6.01347 26.3167L7.73014 19.4517C7.80588 19.1451 7.79298 18.8234 7.69296 18.5239C7.59293 18.2244 7.40989 17.9595 7.16514 17.76L1.61514 13.2217C0.451804 12.27 1.04514 10.385 2.54347 10.27L9.98014 9.7C10.2818 9.67686 10.5715 9.57202 10.8182 9.39673C11.0648 9.22144 11.2591 8.98231 11.3801 8.705L14.3035 2Z",
    stroke: "#FEC00F",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStar);
export default __webpack_public_path__ + "static/media/rating-star.840ca5c38a27cf537bb9bb102e3b80cc.svg";
export { ForwardRef as ReactComponent };